import { render } from "./Messaging.vue?vue&type=template&id=619f5979&scoped=true"
import script from "./Messaging.vue?vue&type=script&lang=js"
export * from "./Messaging.vue?vue&type=script&lang=js"

import "./Messaging.vue?vue&type=style&index=0&id=619f5979&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619f5979"]])

export default __exports__